import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICoupon } from "src/models/Offers/Coupon.models";

interface CouponState {
  coupons: ICoupon[];
  couponToEdit: ICoupon | null;
}

const initialState: CouponState = {
  coupons: [],
  couponToEdit: null,
};

const CouponSlice = createSlice({
  name: "Coupon",
  initialState,
  reducers: {
    setCouponList: (state, action: PayloadAction<ICoupon[]>) => {
      state.coupons = action.payload;
    },
    concatListCoupon: (
      state: CouponState,
      action: PayloadAction<ICoupon[]>
    ) => {
      state.coupons = [...state.coupons.concat(action.payload)];
    },
    setCouponToEdit: (state, action: PayloadAction<ICoupon | null>) => {
      state.couponToEdit = action.payload;
    },
    addCoupon: (state, action: PayloadAction<ICoupon>) => {
      state.coupons.push(action.payload);
    },
    updateCoupon: (state, action: PayloadAction<ICoupon>) => {
      let itemIndex = state.coupons.findIndex(
        item => item.couponId === action.payload.couponId
      );
      if (itemIndex !== -1) state.coupons[itemIndex] = action.payload;
    },
    deleteCoupon: (state, action: PayloadAction<number>) => {
      const newArray = state.coupons.filter(
        item => item.couponId !== action.payload
      );
      state.coupons = newArray;
    },
  },
});

export const {
  setCouponList,
  concatListCoupon,
  setCouponToEdit,
  addCoupon,
  updateCoupon,
  deleteCoupon,
} = CouponSlice.actions;

export default CouponSlice.reducer;
